import moment from 'moment';
import { message } from 'antd';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import get from 'lodash/get';
import * as storesServices from '../services/stores';
import dataProvince from '../components/DataMapVN/province.json';
import dataDistrict from '../components/DataMapVN/district.json';
import dataWard from '../components/DataMapVN/ward.json';

const RESOURCE = 'stores';
const transfromDocument = (record) => {
  if (record.created) {
    const createdAt = record.created;
    record.created = moment.unix(createdAt);
  }
  if (record.updatedAt) {
    const updatedAt = record.updatedAt;
    record.updatedAt = moment.unix(updatedAt);
  }
  if (record.province) {
    const provinceName = dataProvince.RECORDS.find(
      (i) => i.id === record.province,
      );
    record.provinceName = (provinceName || {}).name;
  }
  if (record.district) {
    const districtName = dataDistrict.RECORDS.find(
      (i) => i.id === record.district,
      );
    record.districtName = (districtName || {}).name;
  }
  if (record.ward) {
    const wardName = dataWard.RECORDS.find((i) => i.id === record.ward);
    record.wardName = (wardName || {}).name;
  }

  return record;
};

export default {
  namespace: 'stores',

  state: {
    data: {
      list: [],
      pagination: {
        anchor: '',
        listAnchor: {
          1: '',
        },
      },
    },
    submitting: false,
    formTitle: '',
    formID: '',
    formVisible: false,
    formData: {},
  },

  effects: {
    *fetch({ payload, callback }, { call, put }) {
      let list = [];
      try {
        const response = yield call(storesServices.getList, payload);
        if (response) {
          if (response.stores) {
            list = response.stores.map((item) => {
              transfromDocument(item);
              return item;
            });
          }
          yield put({
            type: 'save',
            payload: {
              list,
              pagination: {
                total: response.total,
                anchor: get(response, ['anchor'], ''),
                listAnchor: {
                  [((payload && payload.current) || 1) + 1]: get(
                    response,
                    ['anchor'],
                    '',
                    ),
                },
              },
            },
          });
        }
      } catch (error) {
        console.log('*fetch -> error', error);
      }
      if (callback) {
        callback(list);
      }
    },
    *loadForm({ payload, callback }, { put }) {
      yield put({
        type: 'changeFormVisible',
        payload: true,
      });

      yield [
      put({
        type: 'saveFormType',
        payload: payload.type,
      }),
      put({
        type: 'saveFormID',
        payload: '',
      }),
      ];
      if (payload.type === 'A') {
        console.log("models store payload ", payload)
        yield [
        put({
          type: 'saveFormTitle',
          payload: 'Thêm mới',
        }),
        put({
          type: 'saveFormData',
          payload: {
            status: '1',
            ...(payload.record || {})
          },
        }),
        ];
      } else if (payload.type === 'E') {
        yield [
        put({
          type: 'saveFormTitle',
          payload: `Chỉnh sửa ${payload.id}`,
        }),
        put({
          type: 'saveFormID',
          payload: payload.id,
        }),
        put({
          type: 'fetchForm',
          payload: {
            id: payload.id,
          },
        }),
        ];
      }
      if (callback) {
        callback();
      }
    },
    *fetchForm({ payload, callback }, { call, put }) {
      let response;
      try {
        payload = Object.assign(payload, { includes: 'partner' });
        response = yield call(storesServices.get, payload.id, payload);
        if (response) transfromDocument(response);
        yield [
        put({
          type: 'saveFormData',
          payload: response,
        }),
        ];
      } catch (error) {
        console.log('*fetch -> error', error);
      }
      if (callback) {
        callback(response);
      }
    },
    *submit({ payload, callback }, { call, put, select }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });

      const params = { ...payload };
      const formType = yield select((state) => state.stores.formType);

      let success = false;
      let response;
      try {
        if (formType === 'E') {
          const id = yield select((state) => state.stores.formID);
          
            params.id = +id;
          response = yield call(storesServices.update, id, params);
          success = true;
        } else {
          response = yield call(storesServices.create, params);
          success = true;
        }
      } catch (error) {
        success = false;
      }

      yield put({
        type: 'changeSubmitting',
        payload: false,
      });

      if (success) {
        message.success('Thành công');
        yield put({
          type: 'changeFormVisible',
          payload: false,
        });
      }
      if (callback && success) {
        callback(response);
      }
    },
    *updateState({ payload, callback }, { call, put, select }) {
      const params = { ...payload };
      let id = params.id;
      try {
        const response = yield call(storesServices.update, id, params);
        if (response === null) {
          message.success('Thay đổi trạng thái thành công');
        } else {
          message.error('Thay đổi trạng thái thất bại');
        }
      } catch (error) {}

      callback();
    },
    *sync({ payload, callback }, { call, put }) {
      try {
        let body = { ...payload };
        yield call(storesServices.sync, body);
        message.success('Đồng bộ thành công');
      } catch (error) {
        message.error('Đồng bộ thất bại');
      }
      yield put({
        type: 'fetch',
      });
    },
  },

  reducers: {
    save(state, action) {
      let pagi = get(action.payload, ['pagination'], {});
      pagi = omit(pagi, ['listAnchor']);
      const aPagi = get(action.payload, 'pagination', {});
      const sPagi = get(state.data, 'pagination', {});
      const listAnchor = Object.assign(
        {},
        get(aPagi, 'listAnchor', {}),
        get(sPagi, 'listAnchor', {}),
        );
      const pagination = Object.assign({}, sPagi, { listAnchor }, pagi);
      return {
        ...state,
        data: {
          ...state.data,
          list: action.payload.list,
          pagination,
        },
      };
    },
    changeFormVisible(state, { payload }) {
      return { ...state, formVisible: payload };
    },
    saveFormTitle(state, { payload }) {
      return { ...state, formTitle: payload };
    },
    saveFormType(state, { payload }) {
      return { ...state, formType: payload };
    },
    saveFormID(state, { payload }) {
      return { ...state, formID: payload };
    },
    saveFormData(state, { payload }) {
      return { ...state, formData: payload };
    },
    changeSubmitting(state, { payload }) {
      return { ...state, submitting: payload };
    },
  },
};
